<template>
  <v-container fluid>
    <div>
      <v-row v-if="dealReportOverallLeads" align="center" justify="center">
        <v-col cols="12" align="center" justify="center">
          <highcharts :options="getChart('All Deals', dealReportOverallLeads)" />
        </v-col>
      </v-row>
      <v-row v-if="dealReportNewLeadsByDealType" align="center" justify="center">
        <v-col cols="12" align="center" justify="center">
          <highcharts :options="getChart('New Deals per Deal Type', dealReportNewLeadsByDealType)" />
        </v-col>
      </v-row>
      <v-row v-if="dealReportCallsByDealType" align="center" justify="center">
        <v-col cols="12" align="center" justify="center">
          <highcharts :options="getChart('Calls By Deal Type', dealReportCallsByDealType)" />
        </v-col>
      </v-row>
      <v-row v-if="dealReportCallBreakdown" align="center" justify="center">
        <v-col cols="12" align="center" justify="center">
          <highcharts :options="getChart('Call Breakdown', dealReportCallBreakdown)" />
        </v-col>
      </v-row>
      <v-row v-if="dealReportNotPitched" align="center" justify="center">
        <v-col cols="12" align="center" justify="center">
          <highcharts :options="getChart('Calls - Not Pitched', dealReportNotPitched)" />
        </v-col>
      </v-row>
      <v-row v-if="dealReportCloseBreakdown" align="center" justify="center">
        <v-col cols="12" align="center" justify="center">
          <highcharts :options="getChart('Calls - Close Breakdown', dealReportCloseBreakdown)" />
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import {
  DEAL_REPORT_NEW_LEADS_BY_DEAL_TYPE,
  DEAL_REPORT_OVERALL_LEADS,
  DEAL_REPORT_CALLS_BY_DEAL_TYPE,
  DEAL_REPORT_CALL_BREAKDOWN,
  DEAL_REPORT_NOT_PITCHED,
  DEAL_REPORT_CLOSE_BREAKDOWN,
} from "@/graphql/queries/deal";
import DealReportMixin from "@/components/deals/mixins/DealReportMixin";

export default {
  name: "DealCompanyReport",
  mixins: [DealReportMixin],
  props: {
    startDate: {
      type: String,
    },
    endDate: {
      type: String,
    },
    dealOwners: {
      type: Array,
    },
    dealTypes: {
      type: Array,
    },
  },
  apollo: {
    dealReportNewLeadsByDealType: {
      query: DEAL_REPORT_NEW_LEADS_BY_DEAL_TYPE,
      fetchPolicy: "no-cache",
      variables() {
        return {
          startDate: this.startDate,
          endDate: this.endDate,
          dealOwners: this.dealOwners,
          dealTypes: this.dealTypes,
        };
      },
      skip() {
        return !this.startDate || !this.endDate;
      },
    },
    dealReportOverallLeads: {
      query: DEAL_REPORT_OVERALL_LEADS,
      fetchPolicy: "no-cache",
      variables() {
        return {
          startDate: this.startDate,
          endDate: this.endDate,
          dealOwners: this.dealOwners,
        };
      },
      skip() {
        return !this.startDate || !this.endDate;
      },
    },
    dealReportCallsByDealType: {
      query: DEAL_REPORT_CALLS_BY_DEAL_TYPE,
      fetchPolicy: "no-cache",
      variables() {
        return {
          startDate: this.startDate,
          endDate: this.endDate,
          dealOwners: this.dealOwners,
          dealTypes: this.dealTypes,
        };
      },
      skip() {
        return !this.startDate || !this.endDate;
      },
    },
    dealReportCallBreakdown: {
      query: DEAL_REPORT_CALL_BREAKDOWN,
      fetchPolicy: "no-cache",
      variables() {
        return {
          startDate: this.startDate,
          endDate: this.endDate,
          dealOwners: this.dealOwners,
        };
      },
      skip() {
        return !this.startDate || !this.endDate;
      },
    },
    dealReportNotPitched: {
      query: DEAL_REPORT_NOT_PITCHED,
      fetchPolicy: "no-cache",
      variables() {
        return {
          startDate: this.startDate,
          endDate: this.endDate,
          dealOwners: this.dealOwners,
        };
      },
      skip() {
        return !this.startDate || !this.endDate;
      },
    },
    dealReportCloseBreakdown: {
      query: DEAL_REPORT_CLOSE_BREAKDOWN,
      fetchPolicy: "no-cache",
      variables() {
        return {
          startDate: this.startDate,
          endDate: this.endDate,
          dealOwners: this.dealOwners,
        };
      },
      skip() {
        return !this.startDate || !this.endDate;
      },
    },
  },
};
</script>
